/* RESPONSIBLE TEAM: team-channels */
import { helper as buildHelper } from '@ember/component/helper';
import { formatMinutes } from 'embercom/lib/duration-formatter';

export function minutesFormatter(params) {
  return formatMinutes(params[0]);
}

export default buildHelper(minutesFormatter);
